import { InMemoryCache, HttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { Preferences } from '@capacitor/preferences'
import { isPlatform } from '@ionic/react'
import { Environment } from '@src/global'
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs'

import introspection from '@src/generated/schema/fragmentTypes.json'

Environment()

const possibleTypes: Record<string, string[]> = (introspection as any)?.possibleTypes ?? {}

export const cache = new InMemoryCache({
  dataIdFromObject: (object) => {
    const id = object?.id

    if (id == null) {
      return undefined
    }

    return String(id)
  },
  possibleTypes,
})

const GRAPHQL_URI = `${window.env.LOGISTIK_BACKEND_URL}/graphql`

export const httpLink = new HttpLink({ uri: GRAPHQL_URI })
export const uploadHttpLink = new UploadHttpLink({ uri: GRAPHQL_URI })
export const authLink = setContext(async (_: any, { headers }: any) => {
  // get the authentication token from local storage if it exists
  const { value } = await Preferences.get({ key: 'token' })
  const ionHeaders = { 'ion-platform': isPlatform('hybrid') ? 'app' : 'web' }

  return {
    headers: {
      ...headers,
      ...ionHeaders,
      ...(value ? { Authorization: `JWT ${String(value)}` } : {}),
    },
  }
})
